module.exports = __webpack_public_path__ + "img/xls.ea50727.svg";